import React, { useState } from "react";

const TagEditor = ({ value = [], onChange, placeholder = "Add tag..." }) => {
    const [input, setInput] = useState("");

    const addTag = () => {
        const v = input.trim();
        if (!v) return;

        onChange([...value, v]);
        setInput("");
    };

    const removeTag = (index) => {
        onChange(value.filter((_, i) => i !== index));
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            addTag();
        }
    };

    return (
        <div className="space-y-2">

            {/* tags */}
            <div className="flex flex-wrap gap-2">
                {value.map((tag, idx) => (
                    <span
                        key={idx}
                        className="px-2 py-2 text-xs bg-red-100 text-red-600 rounded-xl flex items-center gap-1"
                    >
                        {tag}
                        <button
                            onClick={() => removeTag(idx)}
                            className="text-red-400 hover:text-red-600"
                        >
                            ×
                        </button>
                    </span>
                ))}
            </div>

            {/* input */}
            <div className="flex gap-2 my-3">
                <input
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    onKeyDown={handleKeyDown}
                    placeholder={placeholder}
                    className="border px-3 py-2 rounded-md text-m w-full focus:outline-none focus:ring-2 focus:ring-red-100 border-gray-200"
                />
            </div>
        </div>
    );
};

export default TagEditor;